export const MAX_TITLE_LENGTH = 55
export const MAX_HINT_LENGTH = 55
export const MAX_VALUE_LENGTH = 100
export const MAX_CODE_LENGTH = 120
export const MAX_CHECKBOX_LENGTH = 215
